module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/GreenXMark.5f1eec6f.svg";